import "../css/app.css";
import $ from "jquery";
import Autocomplete from "@trevoreyre/autocomplete-js";
import "@iconify/iconify";

// Expose $ and Autocomplete globally for code in the templates
window.$ = window.jQuery = $;
window.Autocomplete = Autocomplete;

// Setup jQuery to include the CSRF token in local non-GET requests
$.ajaxPrefilter(function(options, originalOptions, jqXHR) {
  const isLocal = !options.url.match(/^https?:\/\//) || options.url.match(new RegExp("^https?://" + window.location.host));
  if (isLocal && options.type !== 'GET') {
    jqXHR.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
  }
});

function runGeolocation() {
  const geoOptions = {
    enableHighAccuracy: true,
    timeout: 30000, // 30 seconds
    maximumAge: 300000, // 5 minutes
  };
  
  function zipSuccess(postalCode) {
    console.log("Success!")
    console.log(postalCode);
    location.href = "/" + postalCode.postal_code
  }
  
  function zipError(err) {
    console.warn(`ZIP ERROR(${err.code}): ${err.message}`);
  }

  function geoSuccess(pos) {
    const crd = pos.coords;
    const url = `/ajax/nearest?lat=${crd.latitude}&lon=${crd.longitude}`;

    $.ajax({
      dataType: "json",
      url: url,
      success: zipSuccess,
      error: zipError
    });
  }
  
  function geoError(err) {
    console.warn(`GEO ERROR(${err.code}): ${err.message}`);
  }
  
  navigator.geolocation.getCurrentPosition(geoSuccess, geoError, geoOptions);
}

// Geolocation Logic
function initGeolocation() {
  const isRoot = (location.pathname === "/")
  
  if (isRoot) {
    runGeolocation();
  }

  $('.geo-trigger').on('click', function(e) {
    e.preventDefault();
    runGeolocation();
  });
}

// Autocomplete Logic
function initAutocomplete(selector) {
  const autocompleteElem = document.querySelector(selector);
  if (!autocompleteElem) return;

  new Autocomplete(selector, {
    autoSelect: true,
    submitOnEnter: true,
    search: input => {
      const url = `/ajax/autocomplete?pc=${encodeURI(input)}`
      return new Promise(resolve => {
        if (input.length < 3) {
          return resolve([])
        }
        fetch(url)
          .then(response => response.json())
          .then(data => {
            resolve(data)
          })
      })
    },
    renderResult: (result, props) => `
        <li ${props}>${result.usps_city_name}, ${result.usps_state_code} (${result.postal_code})</li>
    `,
    getResultValue: result => result.usps_city_name + ", " + result.usps_state_code + " " + result.postal_code,
    onSubmit: result => {
      location.href = "/" + result.postal_code;
    }
  });
}

// Forecast AJAX Logic (from home/show)
function setVal(id, value) {
  const elem = $('#' + id);
  if (elem.length) {
    elem.val(value);
    elem.trigger('change');
  }
}

function getPoints(url) {
  $.ajax({
    method: 'GET',
    url: url
  })
  .done(function(result) {
    $.ajax({
      method: 'POST',
      data: {data: JSON.stringify(result), pc: $('#pc').val()},
      dataType: "json",
      url: "/ajax/js/points"
    })
    .done(function(result) {
      setVal("forecast_url", result['forecast_url']);
      setVal('hourly_url', result['hourly_url']);
      setVal('stations_url', result['stations_url']);
      setVal('alerts_url', result['alerts_url']);
    })
  })
}

function twoAjax(url1, url2, id) {
  $.ajax({
    method: 'GET',
    url: url1
  })
  .done(function(result) {
    $.ajax({
      method: 'POST',
      data: {data: JSON.stringify(result), pc: $('#pc').val()},
      dataType: "html",
      url: url2
    })
    .done(function(result) {
      $('#' + id).html(result);
    })
  })
}

function getForecast() {
  const forecastUrl = $('#forecast_url').val();
  twoAjax(forecastUrl, "/ajax/js/daily", "daily");
}

function getHourly() {
  const hourlyUrl = $('#hourly_url').val();
  twoAjax(hourlyUrl, "/ajax/js/hourly", "hourly");
}

function getStations() {
  const stationsUrl = $('#stations_url').val();
  $.ajax({
    method: 'GET',
    url: stationsUrl
  })
  .done(function(result) {
    const obsUrl = result['features'][0]['id'] + '/observations/latest';
    setVal('observations_url', obsUrl);
  })
}

function getObservations() {
  const obsUrl = $('#observations_url').val();
  twoAjax(obsUrl, "/ajax/js/current", "current");
}

function getAlerts() {
  const alertsUrl = $('#alerts_url').val();
  twoAjax(alertsUrl, "/ajax/js/alerts", "alerts");
}

function initForecastHandlers() {
  if($('#extraParam').length && $('#extraParam').val().toUpperCase().includes('JS')) {
    $('#forecast_url').on("change", function() { getForecast() });
    $('#hourly_url').on("change", function() { getHourly() });
    $('#stations_url').on("change", function() { getStations() });
    $('#alerts_url').on("change", function() { getAlerts() });
    $('#observations_url').on("change", function() { getObservations() });
    getPoints($('#points_url').val());
  }
}

function initUnitToggle() {
  $('.unit-toggle span').on('click', function() {
    const $this = $(this);
    if ($this.hasClass('is-active')) return;

    const units = $this.text().includes('F') ? 'imperial' : 'metric';
    
    $.ajax({
      method: 'POST',
      url: '/ajax/update_units',
      data: { units: units }
    })
    .done(function() {
      // Refresh the page to show updated units
      location.reload();
    });
  });
}

$(document).ready(function(){
  initGeolocation();
  initAutocomplete('#autocomplete');
  initAutocomplete('#autocomplete-mobile');
  initUnitToggle();
  for(var i = 1; i <= 24; i++) {
    var source_id = "#dailies-toggle-" + i;
    $(source_id).on('click', function(e){
      var id = e.currentTarget.id.replace('-toggle', '2');
      $("#" + id).toggle(400);
    });
  };

  initForecastHandlers();

  // Mobile menu toggle
  $('.navbar-burger').on('click', function() {
    $('.navbar-burger').toggleClass('is-active');
    $('#navbarMain').toggleClass('is-active');
  });

  // Toggle source switcher on mobile click
  $('.source-switcher').on('click', function(e) {
    if ($(window).width() < 1024) {
      $(this).toggleClass('is-active');
    }
  });

  $(document).on('click', '.alert-collapsible .message-header', function() {
    const $alert = $(this).closest('.alert-collapsible');
    const $body = $alert.find('.message-body');
    const $icon = $(this).find('.iconify');
    
    $body.toggleClass('is-hidden');
    
    if ($body.hasClass('is-hidden')) {
      $icon.attr('data-icon', 'mdi-chevron-down');
    } else {
      $icon.attr('data-icon', 'mdi-chevron-up');
    }
  });

  // Hourly Tooltip Logic
  const $tooltip = $('<div class="hourly-tooltip"></div>').appendTo('body');

  $(document).on('mouseenter touchstart', '.hourly-hit-zone', function(e) {
    const info = $(this).data('info');
    $tooltip.html(info).show();
  });

  $(document).on('mousemove touchmove', '.hourly-hit-zone', function(e) {
    const pageX = e.type === 'touchmove' ? e.originalEvent.touches[0].pageX : e.pageX;
    const pageY = e.type === 'touchmove' ? e.originalEvent.touches[0].pageY : e.pageY;
    
    $tooltip.css({
      left: pageX + 10,
      top: pageY - 35
    });
  });

  $(document).on('mouseleave touchend', '.hourly-hit-zone', function() {
    $tooltip.hide();
  });
});
